import { Steps as AntdSteps } from "@empglabs/backoffice-ui-kit"

const Steps = props => {
  return <AntdSteps {...props} />
}

export default Steps
